import { router } from '@inertiajs/react'
import { Button } from '@/components/ui/button'

export type SectionUnavailableReason = 'provisionando' | 'instancia_indisponivel'

interface Props {
  sectionLabel: string
  workerName: string
  reason: SectionUnavailableReason
}

/**
 * Estado em contexto das seções que dependem de uma instância OpenClaw pronta
 * (SZ-1583, "cadeados viram estados"): em vez de redirect ou porta trancada,
 * a própria página da seção mostra o motivo e um caminho de saída. Sem
 * spinner — apenas um ponto pulsante enquanto a instância é preparada.
 */
export default function SectionUnavailableState({ sectionLabel, workerName, reason }: Props) {
  const provisioning = reason === 'provisionando'

  return (
    <div
      data-testid="worker-section-unavailable"
      className="bg-card rounded-xl border border-border p-8 text-center space-y-4"
    >
      <h2 className="text-[14px] font-semibold text-foreground">{sectionLabel}</h2>
      <div className="flex items-center justify-center gap-2">
        {provisioning && (
          <span className="h-2 w-2 flex-shrink-0 rounded-full bg-warning animate-pulse" aria-hidden="true" />
        )}
        <p className="text-[13px] text-muted-foreground">
          {provisioning
            ? `A instância de ${workerName} ainda está sendo preparada — ${sectionLabel} abre assim que ela ficar pronta.`
            : `A instância de ${workerName} está indisponível no momento — ${sectionLabel} depende dela para funcionar.`}
        </p>
      </div>
      <Button type="button" variant="outline" size="sm" onClick={() => router.reload()}>
        Tentar de novo
      </Button>
    </div>
  )
}
